import { render, staticRenderFns } from "./StaffSelection.vue?vue&type=template&id=f554dcae&scoped=true&"
import script from "./StaffSelection.vue?vue&type=script&lang=js&"
export * from "./StaffSelection.vue?vue&type=script&lang=js&"
import style0 from "./StaffSelection.vue?vue&type=style&index=0&id=f554dcae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f554dcae",
  null
  
)

export default component.exports